import { InputPropertyValue } from "./InputPropertyValue";
import type { PropertyValueProps } from "./types";

export const TextPropertyValue = (props: PropertyValueProps) => (
	<InputPropertyValue {...props} inputType="text" placeholder="enter-text" />
);
